import React, { Component } from "react";
import { Auth } from "aws-amplify";
import './style.css'
import { getQueryParams } from './utils';
import { Link } from 'react-router-dom';
import AgreeModal from './AgreeModal';
import AuthLayout from './AuthLayout';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

export class SignIn extends Component {
  constructor(props) {
    super(props);
    this.emailInput = React.createRef();
    this.passwordInput = React.createRef();
    this.state={
      agreeModal: this.props.agreeModal,
      showPassword: false
    }

  }

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  }
  componentDidMount() {
    this.loadQueryParams();
    this.prefillCredentials(this.props.username, this.props.password);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.username !== this.props.username ||
      prevProps.password !== this.props.password
    ) {
      this.prefillCredentials(this.props.username, this.props.password);
    }
  }

  prefillCredentials = (username, password) => {
    if (!username || !password || !this.emailInput.current || !this.passwordInput.current) {
      return;
    }
    const usernameObj = {
      target: {
        name: 'username',
        value: username
      }
    };
    const passwordObj = {
      target: {
        name: 'password',
        value: password
      }
    };
    this.emailInput.current.value = username;
    this.passwordInput.current.value = password;
    this.props.handleChange(usernameObj);
    this.props.handleChange(passwordObj);
  }
  handleSubmit = (event) => {
    this.props.handleSubmit(event)
  }

  loadQueryParams = () => {
    let queryParams = getQueryParams()
    if (queryParams.username && queryParams.password) {
      let userName = decodeURI(queryParams.username);
      let password = decodeURI(queryParams.password);
      this.emailInput.current.value = userName;
      this.passwordInput.current.value = password;

      let usernameObj = {
        target: {
          name: 'username',
          value: userName
        }
      }
      this.props.handleChange(usernameObj, true);

      let passwordObj = {
        target: {
          name: 'password',
          value: password
        }
      }
      this.props.handleChange(passwordObj, true)
    }
  }

  handleChange = (event) => {
    this.props.handleChange(event)
  }
  handleForgot = (event) => {
    console.log('inside handle logout')
    this.props.handleForgot(event)
  }

  urlSetup = () => {
    let urlencryption = sessionStorage.getItem("urlencryption")
    if (urlencryption) {
      let data = JSON.parse(atob(urlencryption));
      this.emailInput.current.value = data.username;
      this.passwordInput.current.value = data.password;
      sessionStorage.removeItem("urlencryption");
    }
  }

  render() {
    return (
      <AuthLayout>
        <p className="a-errorMessage" hidden={this.props.errorMsg.length <= 0}>{this.props.errorMsg}</p>
        <form onSubmit={this.handleSubmit.bind(this)} className="auth-form">
          <input ref={this.emailInput}
            className="auth-input"
            type="text"
            placeholder="Enter your email"
            name="username"
            required
            onChange={this.handleChange.bind(this)}
          />
          <div className="auth-input-wrap">
            <input ref={this.passwordInput}
              className="auth-input"
              type={this.state.showPassword ? 'text' : 'password'}
              placeholder="Enter your password"
              name="password"
              required
              onChange={this.handleChange.bind(this)}
            />
            <span className="auth-pwd-toggle" onClick={this.toggleShowPassword}>
              {this.state.showPassword ? <VisibilityIcon style={{ height: '20px' }} /> : <VisibilityOffIcon style={{ height: '20px' }} />}
            </span>
          </div>
          <div className="auth-link-row">
            <span onClick={this.handleForgot.bind(this)} className="forgot-pawd">Forgot your password?</span>
          </div>
          <button type="submit" className="auth-btn-primary" disabled={this.props.disableSiginBtn}>Sign In</button>
        </form>

    

        <AgreeModal agreeModal={this.props.agreeModal} closeModal={()=>this.closeModal()}/>
      </AuthLayout>
    )

  }
  closeModal(){
    this.props.closeModal()
    console.log("close modal")
  }
}
export default SignIn;
